import { render, staticRenderFns } from "./AddressDetailPanel.vue?vue&type=template&id=0b1ef2ab&scoped=true&"
import script from "./AddressDetailPanel.vue?vue&type=script&lang=js&"
export * from "./AddressDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddressDetailPanel.vue?vue&type=style&index=0&id=0b1ef2ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ef2ab",
  null
  
)

export default component.exports